<template>
    <div class="kami">
        <div class="top-banner">
            <div>
                <div  :style="tittlestyle" class="fl tittle">
                    <h2>产品中心-电子卡密</h2>
                    <p>提供虚拟商品的发售服务，给商家和用户带来便捷、快速、安全的销售和购买体验</p>
                </div>
                <img  src="/site_static/img/cm-ban.png" alt="" class="fr banner-img" :style="banlogostyle">
            </div>
        </div>
        <div class="cardScreat-special">
            <div class="cardScreatTitle" style="padding: 80px 0 48px 0">
                <div class="con">
                    <h3>您身边的电子卡密</h3>
                    <div class="underline"></div>
                </div>
            </div>
            <div class="special-con">
                <img src="/site_static/img/yuan.png" alt="" class="yuan">
                <div class="conitem conitem1">
                    <img src="/site_static/img/cm_video.png" alt="" class="itemImg">
                    <span>视频网站会员激活码</span>
                </div>
                <div class="conitem conitem2">
                    <img src="/site_static/img/cm_card.png" alt="" class="itemImg">
                    <span>手机话费充值卡</span>
                </div>
                <div class="conitem conitem3">
                    <img src="/site_static/img/cm_ip.png" alt="" class="itemImg">
                    <span>IP卡、网络电话</span>
                </div>
                <div class="conitem conitem4">
                    <img src="/site_static/img/cm_q.png" alt="" class="itemImg">
                    <span>游戏点卡、Q币等充值卡</span>
                </div>
                <div class="conitem conitem5">
                    <img src="/site_static/img/cm_m.png" alt="" class="itemImg">
                    <span>软件序列号、电子书提取码</span>
                </div>
                <div class="conitem conitem6">
                    <img src="/site_static/img/cm_m.png" alt="" class="itemImg">
                    <span>域名、虚拟空间等网站类产品的账号</span>
                </div>
            </div>
        </div>
        <div style="background-color: #f5f8ff;">
            <div class="cardConTitle" style="padding: 58px 0 36px 0">
                <h3>电子卡密功能特色</h3>
            </div>
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/cm_icon_01.png" alt="" class="icon">
                    <div class="member-tit">高度灵活的卡密库设置</div>
                    <div class="member-subtit">可设置不同的卡密分类，设置多规格卡密库，自定义名称，卡密库设置灵活多变，满足您的多样性需求。</div>
                </div>
                <img src="/site_static/img/cm_function01.png" class="member-right">
            </div>
        </div>
        <div>
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <img src="/site_static/img/cm_function02.png" class="member-right">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/product/cm_icon_02.png" alt="" class="icon">
                    <div class="member-tit">更便捷的操作体验</div>
                    <div class="member-subtit">可手动调整发卡顺序，批量设置卡密分类、批量删除卡密库、批量恢复卡密库，人性化的设置，给您提供极大便利。</div>
                </div>
            </div>
        </div>
        <div style="background-color: #f5f8ff;">
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <div class="member-left" style="width: 530px;">
                    <img src="/default/img/product/cm_icon_03.png" alt="" class="icon">
                    <div class="member-tit">快速的数据处理能力</div>
                    <div class="member-subtit">在批量上传中支持一次性导入2Mb的Excel文件，并支持断点续传，上传失败会有提示，可以导出查看后直接再导入，快速的数据处理能力，让您用的更放心。</div>
                </div>
                <img src="/default/img/product/cm_function03.png" class="member-right">
            </div>
        </div>
        <div>
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <img src="/site_static/img/cm_function04.png" class="member-right">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/cm_icon_04.png" alt="" class="icon">
                    <div class="member-tit">清晰直观的数据结构</div>
                    <div class="member-subtit">系统页面结构清晰，交互体验友好，大大降低了操作难度，节省您的操作成本。</div>
                </div>
            </div>
        </div>
        <div style="background-color: #f5f8ff;">
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/cm_icon_05.png" alt="" class="icon">
                    <div class="member-tit">人性化的用户体验</div>
                    <div class="member-subtit">用户完成订单，可在发货信息中，使用一键复制按钮复制所需卡密，操作方便，提高用户满意度 。</div>
                </div>
                <img src="/site_static/img/cm_function05.png" class="member-right">
            </div>
        </div>
        <div>
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <img src="/site_static/img/cm_function06.png" class="member-right">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/cm_icon_06.png" alt="" class="icon">
                    <div class="member-tit">贴心的提示说明</div>
                    <div class="member-subtit">针对卡密库可设置使用说明，用户完成订单，可在订单详情页查看使用说明，节约您的沟通时间。</div>
                </div>
            </div>
        </div>
        <div style="background-color: #f5f8ff;">
            <div class="flex member marginauto " style="padding-bottom: 50px; padding-top: 0px">
                <div class="member-left" style="width: 530px;">
                    <img src="/site_static/img/cm_icon_07.png" alt="" class="icon">
                    <div class="member-tit">更安全的发货方式</div>
                    <div class="member-subtit">自动发货后卡密直接绑定在订单里，用户无法删掉，方便用户随时查询使用。</div>
                </div>
                <img src="/site_static/img/cm_function07.png" class="member-right">
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'kami',
        data(){
            return{
                tittlestyle:{},
                banlogostyle:{}
            }
        },
        created: function () {
            let serf = this
            setTimeout(function () {
                serf.tittlestyle={
                    bottom:'125px',
                    opacity: 1}
                serf.banlogostyle={
                    bottom:'45px',
                    opacity: 1}
            },0)

        }
    }
</script>
<style scoped>
    ul{
        list-style: none;
    }
    p{
        margin: 0;
    }
    .flex{
        display: flex;
    }
    .fl{
        float: left;
    }
    .fr{
        float: right;
    }
    .top-banner{
        background: linear-gradient(90deg,#ff825c,#ff5d5c);
        color: #fff;
        width: 100%;
        height: 480px;
    }
    .top-banner>div{
        width: 1200px;
        margin: auto;
        height: 100%;
        overflow: hidden;
        position: relative;
    }
    .tittle{
        position: absolute;
        height: 220px;
        transition: all .5s;
        bottom: 0;
        opacity: 0;
    }
    .tittle>h2{
        font-size: 30px;
        margin: 50px 20px 28px 0;
        font-weight: 500;
    }
    .tittle>p{
        font-size: 18px;
        width: 500px;
        line-height: 36px;
        margin-bottom: 30px;
        text-align: left;
    }
    .banner-img{
        position: absolute;
        bottom: 0px;
        opacity: 0;
        transition: all .5s;
    }
    .title {
        padding: 80px 0 50px 0;
        text-align: center;
    }
    .title h3 {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 20px;
        font-weight: 500;
    }
    .commission{
        background: url(/site_static/img/free.png) no-repeat;
        background-size: 100% 100%;
        height: 240px;
        text-align: center;
        padding-top: 50px;
        box-sizing: border-box;
        color: #fff;
    }
    .commission-tit {
        font-size: 28px;
        padding-bottom: 16px;
    }
    .commission .free {
        width: 116px;
        height: 36px;
        line-height: 36px;
        box-sizing: border-box;
        border-radius: 4px;
        border: 1px solid #fff;
        margin: 0 auto;
        margin-top: 8px;
    }
    .cardScreatTitle h3 {
        font-size: 26px;
        color: #3b426b;
        text-align: center;
        font-weight: 500;
    }
    .cardScreatTitle .underline {
        width: 100px;
        height: 12px;
        background-color: #ffd9d9;
        border-radius: 2px;
        -moz-border-radius: 2px;
        -webkit-border-radius: 2px;
        position: absolute;
        bottom: -1px;
        left: 50.1%;
        z-index: -1;
    }
    .con {
        position: relative;
    }
    .cardScreat-special .special-con {
        background: url(/site_static/img/cm_bg.png) no-repeat;
        background-position: center center;
        text-align: center;
        position: relative;
        padding-bottom: 92px;
        margin-bottom: 46px;
    }
    .cardScreat-special .special-con .yuan {
        margin-left: 39%;
        /* height: 397px; */
    }
    .conitem1 {
        position: absolute;
        left: 27%;
        top: 21%;
    }
    .conitem2 {
        position: absolute;
        left: 26%;
        top: 45%;
    }
    .conitem3 {
        position: absolute;
        left: 30%;
        bottom: 16%;
    }
    .conitem4 {
        position: absolute;
        right: 27%;
        top: 21%;
    }
    .conitem5 {
        position: absolute;
        right: 25%;
        top: 45%;
    }
    .conitem6 {
        position: absolute;
        right: 25%;
        bottom: 16%;
    }
    .conitem .itemImg {
        float: left;
        margin-top: 20px;
    }
    .conitem span {
        float: left;
        margin-left: 12px;
    }
    .conitem {
        display: inline-block;
        background-color: white;
        height: 64px;
        line-height: 64px;
        padding: 0 36px;
        border-radius: 4px;
        -moz-border-radius: 4px;
        -webkit-border-radius: 4px;
        box-shadow: 0 0 24px #e8e8f1;
        -moz-box-shadow: 0 0 24px #e8e8f1;
        -webkit-box-shadow: 0 0 24px #e8e8f1;
        overflow: hidden;
    }
    .member {
        align-items: center;
        padding-top: 50px;
    }
    .marginauto {
        margin: 0 auto;
        width: 1200px;
    }
    .cardConTitle h3 {
        text-align: center;
        font-size: 26px;
        color: #3b426b;
        font-weight: 500;
    }
    .member-left {
        padding-left: 40px;
    }
    .member-right {
        padding-left: 20px;
    }
    .icon {
        margin-bottom: 20px;
    }
    .member-tit {
        font-size: 26px;
        color: #3b426b;
        padding-bottom: 24px;
    }
    .member-subtit {
        line-height: 30px;
        font-size: 18px;
        color: #5d6494;
        text-align: left;
    }
</style>



// WEBPACK FOOTER //
// src/components/product/kami.vue